import { ObjectMap } from '@ringcentral-integration/core/lib/ObjectMap';

export const usageTypes = ObjectMap.fromKeys([
  'MainCompanyNumber',
  'AdditionalCompanyNumber',
  'CompanyNumber',
  'DirectNumber',
  'CompanyFaxNumber',
  'ForwardedNumber',
  'ForwardedCompanyNumber',
  'ContactCenterNumber',
  'ConferencingNumber',
  'NumberPool',
]);
